import { baseApi } from './baseApi';
import { ActionResult, AiDailySummary, ChatRequest, ChatResponse } from '../types/aiChat';

export const aiChatApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDailySummaries: builder.query<AiDailySummary[], { restaurantId: string; limit?: number }>({
      query: ({ restaurantId, limit = 7 }) => ({
        url: `/restaurants/${restaurantId}/ai-daily-summaries`,
        params: { limit },
      }),
      providesTags: ['AiChat'],
    }),
    askChat: builder.mutation<ChatResponse, { restaurantId: string; request: ChatRequest }>({
      query: ({ restaurantId, request }) => ({
        url: `/restaurants/${restaurantId}/ai-chat/ask`,
        method: 'POST',
        body: request,
      }),
    }),
    confirmAiAction: builder.mutation<ActionResult, { restaurantId: string; actionId: string }>({
      query: ({ restaurantId, actionId }) => ({
        url: `/restaurants/${restaurantId}/ai-chat/confirm-action`,
        method: 'POST',
        body: { actionId },
      }),
    }),
    cancelAiAction: builder.mutation<ActionResult, { restaurantId: string; actionId: string }>({
      query: ({ restaurantId, actionId }) => ({
        url: `/restaurants/${restaurantId}/ai-chat/cancel-action`,
        method: 'POST',
        body: { actionId },
      }),
    }),
  }),
});

export const {
  useAskChatMutation,
  useConfirmAiActionMutation,
  useCancelAiActionMutation,
  useGetDailySummariesQuery,
} = aiChatApi;
